import React from "react"
import { reducer, initialState } from "./reducer"

export const SongsContext = React.createContext({
  state: initialState,
  dispatch: () => null
})

export const SongsProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(reducer, initialState)

  return (
    <SongsContext.Provider value={[ state, dispatch ]}>
    	{ children }
    </SongsContext.Provider>
  )
}